module.exports = __webpack_public_path__ + "img/retrofit_cone.8251c476.svg";